import React from 'react';
import { useTranslation } from '../../utils/LanguageContext';

const ComplexityFilter = ({ selectedLevel, onLevelChange }) => {
  const { t } = useTranslation();
  const levels = [
    { key: 'z', value: null },
    { key: 'a', value: 'a' },
    { key: 'b', value: 'b' },
    { key: 'c', value: 'c' }
  ];

  return (
    <div className="flex flex-wrap gap-2">
      {levels.map(({ key, value }) => (
        <button
          key={key}
          onClick={() => onLevelChange(value)}
          className={`px-4 py-2 rounded-md text-sm font-medium transition-colors
            ${selectedLevel === value
              ? 'bg-blue-500 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
        >
          {t(`modulesPage.complexity.${key}`)}
        </button>
      ))}
    </div>
  );
};

export default ComplexityFilter;
